import { EUserProfilePreferenceAttributeName } from '@userProfile/userProfilePreferences.constants';
import { useUserProfilePreferences } from '@userProfile/userProfilePreferences.hooks';
import React from 'react';

export const useShouldHideArchivedProjects = () => {
  const defaultIsHideArchivedProjects = useUserProfilePreferences<boolean>(
    EUserProfilePreferenceAttributeName.HIDE_PROJECT_LIST_ARCHIVED_PROJECTS,
    true,
  );
  const [shouldHideArchivedProjects, setShouldHideArchivedProjects] =
    React.useState<boolean>(defaultIsHideArchivedProjects);

  return { shouldHideArchivedProjects, setShouldHideArchivedProjects };
};
